import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import zhCn from './zh_cn.json'
import en from './en.json';
// import zhXg from './zh_xg.json';

const changeLange = () => {
  const lang = sessionStorage.getItem('oper_lang');

  if (!lang) {
    sessionStorage.setItem('oper_lang', 'en');

    return 'en';
  }

  return lang;
};

const resources = {
  en_US: {
    translation: en,
  },
  zh_CN: {
    translation: zhCn,
  },
  // zh_XG: {
  //   translation: zhXg,
  // }
};

i18n.use(initReactI18next).init({
  resources,
  lng: changeLange(),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
